// extracted by css-extract-rspack-plugin
export default {"wrapper":"_3c753c7d"};